
export default function Services() {
  const services = [
    {
      icon: 'ri-robot-2-line',
      title: 'AI 챗봇 개발',
      description: '고객 응대부터 내부 업무 지원까지, 24/7 작동하는 지능형 챗봇으로 고객 경험을 혁신합니다',
      features: ['자연어 처리', '다국어 지원', '실시간 학습']
    },
    {
      icon: 'ri-flow-chart',
      title: '업무 프로세스 자동화',
      description: '반복적인 수작업을 AI로 자동화하여 직원들이 더 가치 있는 업무에 집중할 수 있도록 지원합니다',
      features: ['워크플로우 최적화', '데이터 처리', '보고서 자동 생성']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'AI 데이터 분석',
      description: '방대한 데이터에서 인사이트를 추출하고, 비즈니스 의사결정을 위한 예측 분석을 제공합니다',
      features: ['예측 모델링', '트렌드 분석', '실시간 대시보드']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '맞춤형 AI 솔루션',
      description: '귀사의 특정 요구사항에 맞춘 AI 솔루션을 설계하고 구축하여 경쟁 우위를 확보합니다',
      features: ['요구사항 분석', '커스텀 개발', '지속적 개선']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-50 rounded-full px-4 py-2 mb-4">
            <i className="ri-service-line text-teal-600"></i>
            <span className="text-teal-600 text-sm font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            AI 자동화 서비스
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            비즈니스 성장을 가속화하는 포괄적인 AI 솔루션을 제공합니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 group cursor-pointer"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <div className="space-y-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-2">
                    <i className="ri-check-line text-teal-500"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
